module.exports = __webpack_public_path__ + "static/img/iphone-xunjia.7eccad4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download/iphone-xunjia.png
// module id = vIyN
// module chunks = 70